import React from "react"
import { semantic } from '@lexody/design-tokens'
import Icon from '../app_components/Icon'
import { usesDashFormVariant } from '../../utils/formVariant'

class TimeInput extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      timeOpen: false,
      timeOptions: ["7:00 AM", "8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM"]
    }

    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.selectTime = this.selectTime.bind(this)
  }

  toggleDropdown() {
    this.setState({
      timeOpen: !this.state.timeOpen
    })
  }

  selectTime(time) {
    this.props.onChange(time)
    this.toggleDropdown()
  }

  renderDropdownOptions() {
    return this.state.timeOptions.map((time, i) => {
      return(
        <div
          className="lex-dropdown__item"
          style={{ textAlign: 'center' }}
          onClick={() => this.selectTime(time)}
          key={i}
          role="option"
        >
          {time}
        </div>
      )
    })
  }

  renderDashField() {
    const { label, value, placeholder, inputError = '' } = this.props;

    return (
      <div className="lex-dash-field lex-dash-field--blue lex-dash-field--dropdown">
        {label && <label className="lex-dash-field__label">{label}</label>}
        <button
          type="button"
          className="lex-dash-field__selectTrigger"
          onClick={() => this.toggleDropdown()}
          aria-expanded={this.state.timeOpen}
        >
          <span className={`lex-dash-field__selectValue${!value ? ' lex-dash-field__selectValue--placeholder' : ''}`}>
            {value || placeholder}
          </span>
          <Icon
            name={this.state.timeOpen ? 'angle-up' : 'angle-down'}
            size={16}
            color={semantic.primary.surface.default}
          />
        </button>
        {inputError.length > 0 && <p className="lex-dash-field__error">{inputError}</p>}
        {this.state.timeOpen && (
          <div className="lex-dash-dropdown">
            <div className="lex-dropdown__list">
              {this.renderDropdownOptions()}
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { variant } = this.props;

    if (usesDashFormVariant(variant)) {
      return this.renderDashField();
    }

    return(
      <div className="lex-field time-input">
          <p className="lex-field__label">{this.props.label}</p>
          {this.props.inputError.length > 0 && <p className="lex-field__error">{this.props.inputError}</p>}
        <div className="time-input__control">
          <div
            className="time-input__trigger"
            onClick={this.toggleDropdown}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.toggleDropdown();
              }
            }}
            role="button"
            tabIndex={0}
            aria-expanded={this.state.timeOpen}
            aria-haspopup="listbox"
          >
            <div className="lex-input lex-input--blue lex-input--plain lex-input--select">
              <input
                readOnly
                value={this.props.value}
                className="lex-input__control"
                placeholder={this.props.placeholder}
                tabIndex={-1}
                aria-hidden="true"
              />
            </div>
          </div>
          {this.state.timeOpen &&
            <div className="time-input__dropdown">
              <div className="lex-dropdown__panel dropdownContainer">
                {this.renderDropdownOptions()}
              </div>
            </div>}
        </div>
      </div>
    )
  }
}

export default TimeInput;
